"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const HR = _styledComponents.default.hr`
	height: 1px;
	color: ${_constants.colours.separator};
	background: ${_constants.colours.separator};
	font-size: 0;
	border: 0;
`;
var _default = HR;
exports.default = _default;